export function safeNumber(n) {
    return typeof n === "number"
        ? n
        : NaN;
}
//# sourceMappingURL=safeNumber.js.map